import React, { useState } from "react";
import { DynamicTable } from "@maherunlocker/custom-react-table";
import { useSnapshot } from "valtio";

import {
    setIsHistoryModalOpened,
    setIsInlineErrorCleared,
    setNumberActive,
    setNumberArchive,
    setPaymentMethodsData,
    setSelectedPaymentMethods,
    store as choiceStore,
    setListFranchiseArchived,
    setDataArchive,
    setIsActionsClicked,
    setIsEdited,
    setActions,
    setValidationAction,
    setArchivedModesInFranchise,
    setIsDataUpdated,
} from "../store";
import { store } from "../../../../components/VerticalLayout/store";
import { clearData } from "@components/Common/MultiCustomCreatableSelection/store";
import { clearMultiCustomSelectionData } from "@components/Common/MultiCustomSelect/store";

import { ConfirmationUpdatingDataMessageModal } from "@components/Common/ConfirmationUpdatingDataMessageModal";
import { ConfirmationInitializationMessage } from "@components/Common/ConfirmationInitializationMessage";
import { useCallbackPrompt } from "@hooks/useCallbackPrompt";

import { CustomSideFilter } from "./CustomSideFilter";
import HistoryModal from "../HistoryModal";
import { ConfirmationActivePaymentMethod } from "./ConfirmationActivePaymentMethod";
import { ConfirmationActivationDeactivationMessageModal } from "@components/Common/ConfirmationActivationDeactivationMessageModal";
import { store as StoreConfirmationActivationDeactivation } from "@components/Common/ConfirmationActivationDeactivationMessageModal/store";

import "./index.css";
import "../ShopsPaymentMethod/index.css";
import "@assets/swal.css";
import "@assets/theme.css";
import "react-toastify/dist/ReactToastify.css";
import { arrayOfCustomColumns } from "./hooks";
import PaymentMethodFormWrapper from "./PaymentMethodFormWrapper";
import { useAuthHeader } from "../../../../api/headersKeycloak";
import { useFetchGlobal } from "../../../../api/hooks";
import { fetchSupport } from "../hooks";
import { useTranslation } from "react-i18next";

type PaymentMethodsType = {
    isArchivedPaymentMethodsClicked: boolean;
    setIsArchivedPaymentMethodsClicked: Function;
};

export default function PaymentMethods({
    isArchivedPaymentMethodsClicked,
    setIsArchivedPaymentMethodsClicked,
}: PaymentMethodsType) {
    const { t } = useTranslation();
    const { oneShop, shopID, userID, franchiseID, operatorID } = useSnapshot(
        store
    );
    const { activationDeactivationMessageModalOpened } = useSnapshot(
        StoreConfirmationActivationDeactivation
    );
    const getAuthHeader = useAuthHeader();
    const {
        isDataUpdated,
        isHistoryModalOpened,
        isActionsClicked,
        isEdited,
        actions,
        validationAction,
        key,
    } = useSnapshot(choiceStore);
    const { fetchGlobal } = useFetchGlobal();
    const shopId: string = oneShop ? shopID : "0";
    const didMountRef = React.useRef(false);
    const i18nextLng = localStorage.getItem("i18nextLng") || "fr";
    const uuidUser = localStorage.getItem("uuidUser");

    const [isConsult, setIsConsult] = React.useState<boolean>(false);
    const [isAddChoiceClicked, setIsAddChoiceClicked] = useState(false);
    const [
        isModalConfirmationOpened,
        setIsModalConfirmationOpened,
    ] = React.useState<boolean>(false);
    const [showPrompt, confirmNavigation, cancelNavigation] = useCallbackPrompt(
        isEdited
    );
    const [
        isAddNewChoiceButtonClicked,
        setIsAddNewChoiceButtonClicked,
    ] = useState(false);
    const [
        isInInitializationModalOpened,
        setIsInInitializationModalOpened,
    ] = React.useState<boolean>(false);
    const [filterActive, setLocalFilterActive] = React.useState<boolean>(false);
    const [paymentMethod, setPaymentMethod] = useState<any[]>([]);

    const [selectedRows, setSelectedRows] = React.useState<any[]>([]);
    const [data, setData] = React.useState<any>({});

    let urlArchive: string = `${process.env.REACT_APP_API_V2_URL}/settings/general/paymentMethod?userId=${userID}&shopId=${shopId}&franchiseId=${franchiseID}&type=archived`;
    let urlActive: string = `${process.env.REACT_APP_API_V2_URL}/settings/general/paymentMethod?userId=${userID}&shopId=${shopId}&franchiseId=${franchiseID}&type=activated`;

    React.useEffect(() => {
        let localShop: string[] = [];
        let array: any = [];

        selectedRows.forEach((element: any) => {
            array.push({ [element.idShop]: element.id });
            localShop.push(element.Boutique);
        });
        setSelectedPaymentMethods(array);

        setNumberActive(
            data.othersData !== undefined ? data.othersData.activated : 0
        );
        setNumberArchive(
            data.othersData !== undefined ? data.othersData.archived : 0
        );

        setListFranchiseArchived(
            data.othersData !== undefined &&
                data.othersData.dataArchive !== undefined &&
                isArchivedPaymentMethodsClicked
                ? data?.othersData?.dataArchive.data
                : []
        );

        setDataArchive(
            data.othersData !== undefined &&
                data.othersData.archivedData !== undefined
                ? data.othersData.archivedData.data
                : []
        );
        setArchivedModesInFranchise(
            data.othersData !== undefined &&
                data.othersData.dataArchive !== undefined
                ? data?.othersData?.dataArchive.data
                : []
        );
        setPaymentMethodsData(data.data);
    }, [data, selectedRows, isArchivedPaymentMethodsClicked]);

    React.useEffect(() => {
        if (filterActive) setIsAddChoiceClicked(false);
    }, [filterActive]);

    React.useEffect(() => {
        clearData();
        clearMultiCustomSelectionData();
    }, [isAddChoiceClicked, paymentMethod]);

    React.useEffect(() => {
        setActions(confirmNavigation);
        setIsActionsClicked(showPrompt as boolean);
        setValidationAction(cancelNavigation);
    }, [showPrompt, confirmNavigation, cancelNavigation]);

    React.useEffect(() => {
        setIsAddChoiceClicked(false);
        if (didMountRef.current) {
            setIsDataUpdated(true);
        } else {
            didMountRef.current = true;
        }
    }, [i18nextLng]);

    React.useEffect(() => {
        fetchSupport(userID, franchiseID, i18nextLng, t, fetchGlobal);
        // eslint-disable-next-line
    }, []);
    return (
        <React.Fragment>
            <div
                style={{
                    display: "grid",
                    minHeight: oneShop ? "650px" : "600px",
                    gridTemplateColumns: isAddChoiceClicked
                        ? "2fr 1fr "
                        : "auto",
                    gridColumnGap: "4px",
                    border: 0,
                }}
            >
                <DynamicTable
                    key={key}
                    requestHeader={{
                        "Accept-Language": i18nextLng,
                        ...getAuthHeader,
                    }}
                    url={
                        isArchivedPaymentMethodsClicked ? urlArchive : urlActive
                    }
                    canSelect
                    setData={setData}
                    customSelect
                    setSelectedRows={setSelectedRows}
                    canMovedCheckboxLeftOnExpand
                    customJsxSideFilterButton={
                        <CustomSideFilter
                            selectedRows={selectedRows}
                            choice={paymentMethod}
                            setIsInInitializationModalOpened={
                                setIsInInitializationModalOpened
                            }
                            setDataIsUpdated={setIsDataUpdated}
                            setLocalFilterActive={setLocalFilterActive}
                            setIsAddChoiceClicked={setIsAddChoiceClicked}
                            isAddChoiceClicked={isAddChoiceClicked}
                            setIsModalConfirmationOpened={
                                setIsModalConfirmationOpened
                            }
                            isModalConfirmationOpened={
                                isModalConfirmationOpened
                            }
                            isArchivedPaymentMethodsClicked={
                                isArchivedPaymentMethodsClicked
                            }
                            setIsArchivedPaymentMethodsClicked={
                                setIsArchivedPaymentMethodsClicked
                            }
                        />
                    }
                    canResize
                    actionColumn={(e: any) => {
                        return e.selectedRow.subRows === undefined ? (
                            <div></div>
                        ) : null;
                    }}
                    showGlobalFilter
                    showFilter
                    setLocalFilterActive={setLocalFilterActive}
                    filterActive={filterActive}
                    arrayOfCustomColumns={arrayOfCustomColumns({
                        oneShop,
                        selectedRows,
                        userID,
                        shopId,
                        franchiseID,
                        operatorID,
                        uuidUser,
                        setPaymentMethod,
                        setIsAddChoiceClicked,
                        setIsModalConfirmationOpened,
                        isModalConfirmationOpened,
                        setSelectedRows,
                        isArchivedPaymentMethodsClicked,
                        setIsConsult,
                    })}
                    setDataIsUpdated={
                        setIsDataUpdated as
                            | React.Dispatch<
                                  React.SetStateAction<number | boolean>
                              >
                            | undefined
                    }
                    dataIsUpdated={isDataUpdated}
                    elevationTable={1}
                    minHeight={oneShop ? "500px" : "450px"}
                    maxHeight={oneShop ? "500px" : "450px"}
                    name="Choice"
                />
                {isAddChoiceClicked ? (
                    <PaymentMethodFormWrapper
                        allDataShops={
                            data.othersData !== undefined &&
                            !isArchivedPaymentMethodsClicked &&
                            data.othersData.allData !== undefined
                                ? data.othersData.allData.data
                                : []
                        }
                        dataChoice={paymentMethod}
                        setDataChoice={setPaymentMethod}
                        isAddChoiceClicked={isAddChoiceClicked}
                        setIsAddChoiceClicked={setIsAddChoiceClicked!}
                        paymentMethod={paymentMethod}
                        isAddNewChoiceButtonClicked={
                            isAddNewChoiceButtonClicked
                        }
                        setIsAddNewChoiceButtonClicked={
                            setIsAddNewChoiceButtonClicked
                        }
                        userData={{
                            userId: userID,
                            shopId,
                            franchiseId: franchiseID,
                        }}
                        isEdited={isEdited}
                        setIsEdited={setIsEdited}
                        isConsult={isConsult}
                        setIsConsult={setIsConsult}
                        setLocalFilterActive={setLocalFilterActive}
                    />
                ) : null}
            </div>
            {isInInitializationModalOpened === true ? (
                <ConfirmationInitializationMessage
                    isModalOpened={isInInitializationModalOpened}
                    setIsModalOpened={setIsInInitializationModalOpened}
                    setIsClicked={setIsAddNewChoiceButtonClicked}
                    isClicked={isAddNewChoiceButtonClicked}
                    setIsEdited={setIsEdited}
                    setIsInlineErrorCleared={setIsInlineErrorCleared}
                />
            ) : null}
            {isActionsClicked === true ? (
                <ConfirmationUpdatingDataMessageModal
                    validationAction={validationAction}
                    actions={actions}
                    isModalOpened={isActionsClicked}
                    setIsModalOpened={setIsActionsClicked}
                    setIsEdited={setIsEdited}
                />
            ) : null}
            {isHistoryModalOpened ? (
                <HistoryModal
                    ids={selectedRows}
                    setIsModalOpened={setIsHistoryModalOpened}
                    isModalOpened={isHistoryModalOpened}
                />
            ) : null}
            {isModalConfirmationOpened === true && (
                <ConfirmationActivePaymentMethod
                    setIsModalConfirmationOpened={setIsModalConfirmationOpened}
                    isModalConfirmationOpened={isModalConfirmationOpened}
                    setDataIsUpdated={setIsDataUpdated}
                    selectedRows={selectedRows}
                />
            )}
            {activationDeactivationMessageModalOpened && oneShop && (
                <ConfirmationActivationDeactivationMessageModal />
            )}
        </React.Fragment>
    );
}
